import React from 'react';
import { FunctionComponent } from 'react';
import HomePageMenuItemComp, {HomePageMenuItem} from './HomePageMenuItemComp';

interface HomePageMenuProps
{
    menuItems: HomePageMenuItem[];
}

const HomePageMenu: FunctionComponent<HomePageMenuProps> = (props) =>
{
    /** The menu items */
    let cmpMenuItems = props.menuItems.map((menuItem, index) =>
        <HomePageMenuItemComp
            key={index}
            menuItem={menuItem}
        />
    );

    /** Render */
    return (
        <div className="home-page-menu">
            {cmpMenuItems}
        </div>
    );
}

export default HomePageMenu;